import { ControlValueAccessor } from '@angular/forms';

export class HisControlValueAccessor implements ControlValueAccessor {

    onModelChange: any = () => {};
    onModelTouched: any = () => {};

    setDisabledState?(isDisabled: boolean): void {}

    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }

    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }

    writeValue(model: any): void {}

}
